import React from 'react';
import brandIcon from '../assets/brand-icon.png';
import brandWordmark from '../assets/brand-wordmark.png';

interface BrandLogoProps {
  /** Höhe des Schriftzugs in px (Icon wird passend mitskaliert) */
  height?: number;
  /** Brillen-Icon links vom Schriftzug anzeigen */
  withIcon?: boolean;
  /** Nur das Icon (z. B. für enge Plätze) */
  iconOnly?: boolean;
  className?: string;
}

/**
 * ELFHALBE Logo (Icon + Schriftzug) als Bild-Assets.
 * Quelle: frontend/src/assets/logo-*.png, webfertig verkleinert
 * via renderings/scripts/process_logos.py
 */
const BrandLogo: React.FC<BrandLogoProps> = ({
  height = 20,
  withIcon = false,
  iconOnly = false,
  className,
}) => {
  const iconSize = Math.round(height * 1.9);

  return (
    <span
      className={className}
      style={{ display: 'inline-flex', alignItems: 'center', gap: Math.round(height * 0.55) }}
    >
      {(withIcon || iconOnly) && (
        <img src={brandIcon} alt={iconOnly ? 'ELFHALBE' : ''} style={{ height: iconSize }} />
      )}
      {!iconOnly && <img src={brandWordmark} alt="ELFHALBE" style={{ height }} />}
    </span>
  );
};

export default BrandLogo;
